import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetFundrasing } from '../../store/fundrasing'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { fundrasingExportColumns } from '../../config/exportColumns/fundrasingExportColumns'

function ApnaMandalPortal() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Apna mandal</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetFundrasing({
										...params,
										...exportFilters,
										paidtoportal: true,
										page: 1,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={fundrasingExportColumns}
							fileName="Apna_Mandal_Contribution"
							sheetName="Apna Mandal"
							buttonText="Export Portal Contribution"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default ApnaMandalPortal
